import React from 'react'
import './pagelayout.css'
import './pagelayout_desktop.css'


export function HeaderLayout({ props, children }) {
    return (
        <header id="page-layout-header">
            <div id='page-header-content'>
                {children}
            </div>
        </header>
    );
}


export function FooterLayout({ children }) {
    return (
        <footer id="page-layout-footer">
            <div className='page-layout footer-section'>
                <p className="footnote">&copy; 2025 by Tori Jensen</p>
            </div>
            <div className='page-layout footer-section'>
                {children}
            </div>
        </footer>
    )
}

export function PgLayoutGrid({ children }) {
    return (
        <div className="pglayout-grid">
            {React.Children.map(children, child =>
                <div className="pglayout-grid-item">{child}</div>)}
        </div>
    )
}

